// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Gt5JD4,
.SFSLJh {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: var(--spacing-2);
  padding: var(--spacing-2);
  background: var(--product-card-background);
  border-radius: var(--radius-s);
  box-shadow: var(--card-box-shadow);
  cursor: pointer;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
  width: 260px;
  border: none;
  text-align: left;
  min-height: var(--product-card-min-height, 64px);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);
  }

  &:focus {
    outline: 2px solid var(--surface-primary-medium);
    outline-offset: 2px;
  }
}

.dbzM3L {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background: var(--product-card-icon-container-bg);
  border-radius: 50%;
  flex-shrink: 0;
}

.dbzM3L svg,
.dbzM3L img {
  width: 16px;
  height: 16px;
  filter: var(--product-card-icon-filter);
}

.CDLRgR {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  min-height: 48px;
  min-width: 0;
}

.dCPgxC {
  font-family: var(--font-family-base);
  font-weight: var(--type-subtitle-md-font-weight);
  font-size: var(--type-subtitle-md-font-size);
  line-height: var(--type-subtitle-md-line-height);
  color: var(--product-card-title-color);
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fG6aQU {
  display: flex;
  align-self: stretch;
  gap: var(--spacing-0-5);
  min-width: 0;
  overflow: hidden;
}

.MCiKA4 {
  font-family: var(--font-family-base);
  font-weight: var(--type-label-sm-regular-font-weight);
  font-size: var(--type-label-sm-font-size);
  line-height: var(--type-label-sm-regular-line-height);
  color: var(--product-card-status-color);
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.HZ6ULN {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  filter: var(--product-card-icon-filter);
  align-self: flex-end;
  margin-top: auto;
}

.oBR5Gw {
  flex-shrink: 0;
  align-self: flex-end;
  margin-top: auto;
}

.SFSLJh {
  .dbzM3L {
    background: var(--product-card-background-contracted);
  }

  .dbzM3L svg,
  .dbzM3L img {
    filter: var(--product-card-icon-filter-contracted);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/ProductCard/ProductCard.module.css"],"names":[],"mappings":"AAAA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,0CAA0C;EAC1C,8BAA8B;EAC9B,kCAAkC;EAClC,eAAe;EACf;;wBAEsB;EACtB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gDAAgD;;EAEhD;IACE,2BAA2B;IAC3B,+CAA+C;EACjD;;EAEA;IACE,gDAAgD;IAChD,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iDAAiD;EACjD,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,gDAAgD;EAChD,4CAA4C;EAC5C,gDAAgD;EAChD,sCAAsC;EACtC,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,qDAAqD;EACrD,yCAAyC;EACzC,qDAAqD;EACrD,uCAAuC;EACvC,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,uCAAuC;EACvC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE;IACE,qDAAqD;EACvD;;EAEA;;IAEE,kDAAkD;EACpD;AACF","sourcesContent":[".card,\n.cardContracted {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: var(--spacing-2);\n  padding: var(--spacing-2);\n  background: var(--product-card-background);\n  border-radius: var(--radius-s);\n  box-shadow: var(--card-box-shadow);\n  cursor: pointer;\n  transition:\n    transform 0.2s ease,\n    box-shadow 0.2s ease;\n  width: 260px;\n  border: none;\n  text-align: left;\n  min-height: var(--product-card-min-height, 64px);\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);\n  }\n\n  &:focus {\n    outline: 2px solid var(--surface-primary-medium);\n    outline-offset: 2px;\n  }\n}\n\n.iconContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 32px;\n  height: 32px;\n  background: var(--product-card-icon-container-bg);\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.iconContainer svg,\n.iconContainer img {\n  width: 16px;\n  height: 16px;\n  filter: var(--product-card-icon-filter);\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  justify-content: space-between;\n  min-height: 48px;\n  min-width: 0;\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-weight: var(--type-subtitle-md-font-weight);\n  font-size: var(--type-subtitle-md-font-size);\n  line-height: var(--type-subtitle-md-line-height);\n  color: var(--product-card-title-color);\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.statusContainer {\n  display: flex;\n  align-self: stretch;\n  gap: var(--spacing-0-5);\n  min-width: 0;\n  overflow: hidden;\n}\n\n.status {\n  font-family: var(--font-family-base);\n  font-weight: var(--type-label-sm-regular-font-weight);\n  font-size: var(--type-label-sm-font-size);\n  line-height: var(--type-label-sm-regular-line-height);\n  color: var(--product-card-status-color);\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n}\n\n.chevron {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  filter: var(--product-card-icon-filter);\n  align-self: flex-end;\n  margin-top: auto;\n}\n\n.progressIndicator {\n  flex-shrink: 0;\n  align-self: flex-end;\n  margin-top: auto;\n}\n\n.cardContracted {\n  .iconContainer {\n    background: var(--product-card-background-contracted);\n  }\n\n  .iconContainer svg,\n  .iconContainer img {\n    filter: var(--product-card-icon-filter-contracted);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `Gt5JD4`,
	"cardContracted": `SFSLJh`,
	"iconContainer": `dbzM3L`,
	"content": `CDLRgR`,
	"title": `dCPgxC`,
	"statusContainer": `fG6aQU`,
	"status": `MCiKA4`,
	"chevron": `HZ6ULN`,
	"progressIndicator": `oBR5Gw`
};
module.exports = ___CSS_LOADER_EXPORT___;
